import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import TrackingPage from './pages/TrackingPage';
import Services from './pages/Services';
import Contacts from './pages/Contacts';
import Privacy from './pages/Privacy';

function App() {
  return (
    <div className="site-shell">
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<Navigate to="/" replace />} />
          <Route path="/tracking" element={<TrackingPage />} />
          <Route path="/tracking/:number" element={<TrackingPage />} />
          <Route path="/faberlic" element={<TrackingPage />} />
          <Route path="/faberlic/:number" element={<TrackingPage />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
